import { z } from 'zod';
import { EmailPreferencesResponseSchema } from './EmailPreferencesResponse';
import { MerchantIdOrPlatformSchema } from './MerchantIdOrPlatformIdRequest';
import { UserRoles } from '../../common/types/UserRole';
import type { UserRole } from '../../contexts';

const UserResponseSchema = z.object({
  id: z.string({
    required_error: 'id is required',
    invalid_type_error: 'id must be a string'
  }),
  cognitoId: z.string({
    required_error: 'cognitoId is required',
    invalid_type_error: 'cognitoId must be a string'
  }),
  merchantId: MerchantIdOrPlatformSchema,
  email: z
    .string({
      required_error: 'merchantId is required',
      invalid_type_error: 'merchantId must be a string'
    })
    .email('Please enter a valid email'),
  mobile: z.string({
    required_error: 'mobile is required',
    invalid_type_error: 'mobile must be a string'
  }),
  name: z.string({
    required_error: 'name is required',
    invalid_type_error: 'name must be a string'
  }),
  title: z
    .string({
      required_error: 'title is required',
      invalid_type_error: 'title must be a string'
    })
    .default('N/A'),
  permissions: z.object({
    readOnlyAccess: z
      .boolean({
        required_error: 'readOnlyAccess is required',
        invalid_type_error: 'readOnlyAccess must be a boolean'
      })
      .default(false),
    paymentAssistAgreement: z
      .boolean({
        required_error: 'paymentAssistAgreement is required',
        invalid_type_error: 'paymentAssistAgreement must be a boolean'
      })
      .default(false)
  }),
  emailPreferences: EmailPreferencesResponseSchema.default({
    enableAllNotifications: false
  }),
  accountArchived: z
    .boolean({
      required_error: 'accountArchived is required',
      invalid_type_error: 'accountArchived must be a boolean'
    })
    .default(false),
  accountLocked: z
    .boolean({
      required_error: 'accountLocked is required',
      invalid_type_error: 'accountLocked must be a boolean'
    })
    .default(false),
  // role: z.string({
  //   required_error: 'role is required',
  //   invalid_type_error: 'role must be a string'
  // })
  // role: z
  //   .string({
  //     required_error: 'role is required',
  //     invalid_type_error: 'role must be a string'
  //   })
  //   .refine(
  //     (role: string): role is UserRole => UserRoles.includes(role as UserRole),
  //     { message: 'role must be a valid UserRole' }
  //   )
  role: z.custom<UserRole>(
    (role) => role as UserRole,
    `role must be one of ["${UserRoles.join('", "')}"]`
  )
  // status: z
  //   .string()
  // .refine(
  //   (productType: string): productType is PolStatus =>
  //     PolStatuses.includes(productType as PolStatus),
  //   { message: 'status must be a valid PolStatus' }
  // ),
});

type UserResponse = ReturnType<typeof UserResponseSchema.parse>;

export { type UserResponse, UserResponseSchema };
